var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body-color",attrs:{"id":"app"}},[(!_vm.isInMaintenance)?_c('Header2',{attrs:{"menu":_vm.menu},on:{"onLoadProducts":_vm.loadProductsInCat}}):_vm._e(),_c('router-view'),(_vm.isMatrix)?_c('FloatingButton',{attrs:{"phone":'523481133967'}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }